export const NOTIFICATION_TYPES = ['warning', 'info', 'error'] as const;
export type NotificationType = typeof NOTIFICATION_TYPES[number];
